import React, { useState } from "react";
import IdleJs from "idle-js";
import { Typography } from "@mui/material";
import { userLoginToken } from "utils/general-utils";
import { navigate } from "utils/navigation";
import Settings from "../settings";
import { Button, Modal } from "./haven-design";
import { DialogActions, DialogContent } from "./haven-design/modal/dialog";

const IDLE_LOGOUT_WAIT = Settings.idle_logout_wait || 20 * 60 * 1000; // 20 mins default
const STAY_LOGGED_IN_WAIT = 60 * 1000; // 60 seconds

const setupIdleTracker = (onIdle: () => void): void => {
  // @ts-ignore
  const idle = new IdleJs({
    events: ["mousemove", "keydown", "mousedown", "touchstart"],
    idle: IDLE_LOGOUT_WAIT,
    onIdle,
  });

  idle.start();
};

export const TimeoutLogoutComponent: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleLogout = () => {
    setModalOpen(false);
    navigate("/logout");
  };

  let logoutTimeout: ReturnType<typeof setTimeout> | null = null;

  const cancelTimeout = () => logoutTimeout && clearTimeout(logoutTimeout);

  const stayLoggedIn = () => {
    cancelTimeout();
    setModalOpen(false);
  };

  const onIdle = () => {
    if (!userLoginToken()) return;

    logoutTimeout = setTimeout(() => handleLogout(), STAY_LOGGED_IN_WAIT);
    setModalOpen(true);
  };

  if (Settings.env !== "development" && Settings.env !== "demo") {
    setupIdleTracker(onIdle);
  }

  return (
    <Modal
      isOpen={modalOpen}
      onRequestClose={stayLoggedIn}
      title="You are about to be logged out"
      small
    >
      <DialogContent>
        <Typography variant="subtitle1">Do you want to say logged in?</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" size="S" onClick={handleLogout}>
          Logout
        </Button>
        <Button color="primary" size="S" marginLeft onClick={() => stayLoggedIn()}>
          Stay logged in
        </Button>
      </DialogActions>
    </Modal>
  );
};
